import { useFormContext, useFormState } from 'react-hook-form'

export default function useErroredFieldState(name) {
    const { control, getFieldState } = useFormContext()
    const formState = useFormState({ control, name })
    return getFieldState(name, formState)
}
